import { render, staticRenderFns } from "./BpcTableDocuments.vue?vue&type=template&id=062797aa&"
import script from "./BpcTableDocuments.vue?vue&type=script&lang=js&"
export * from "./BpcTableDocuments.vue?vue&type=script&lang=js&"
import style0 from "./BpcTableDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports